import { requireAuth } from '@/features/auth/guards/require-auth'
import { positionsListQuery } from '@/features/references/positions/positions-query'
import { UsersPage } from '@/features/references/users/users-page'
import { usersListQuery } from '@/features/references/users/users-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/references/users')({
  beforeLoad: requireAuth,
  loader: async ({ context }) => {
    // Prefetch both — user list + positions cache used by PositionSelect
    // inside create/edit dialogs.
    await Promise.all([
      context.queryClient.ensureQueryData(usersListQuery()),
      context.queryClient.ensureQueryData(positionsListQuery()),
    ])
  },
  component: UsersPage,
  staticData: { crumb: messages.crumbs.refUsers },
})
